import { Outlet } from 'react-router-dom';

import { paths } from '@/routes/paths';

import { RouteTabs } from './RouteTabs';

/**
 * "Find Talent" in the sidebar: searching for new people and the ones the
 * team already saved, as two tabs. Both need the same permission, which the
 * route around this checks, so there is nothing to filter here.
 */
const TABS = [
  { to: paths.company.candidates, label: 'Find Talent', icon: 'userSearch' },
  { to: paths.company.talentPool, label: 'Saved candidates', icon: 'usersStar' },
];

export function CandidatesSection() {
  return (
    // A flex column, so the tab underneath can run to the bottom of the screen.
    <div className="flex flex-col portrait:flex-1">
      <RouteTabs label="Candidates" tabs={TABS} />
      <Outlet />
    </div>
  );
}
